






































import { Vue, Component } from "vue-property-decorator";
import CopiedTestQuestionItem from "@/components/tests/CopiedTestQuestionItem.vue";
import CustomButton from "@/components/form/CustomButton.vue";

@Component({
  components: { CustomButton, CopiedTestQuestionItem }
})
export default class CopiedTestsQuestion extends Vue {
  get copiedTestQuestions() {
    return this.$store.getters["tests/TestsQuestions/GET_QUESTIONS"];
  }

  deleteAllQuestion() {
    this.$store.commit("tests/TestsQuestions/DELETE_ALL_QUESTIONS");
  }

  beforeDestroy() {
    this.$store.commit("tests/TestsQuestions/DELETE_ALL_QUESTIONS");
  }

  goToTestForm() {
    this.$router.push({ name: "testNew", query: { isSetQuestion: "true" } });
  }
}
